var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.25H6C3.93 3.25 2.25 4.93 2.25 7V13C2.25 15.07 3.93 16.75 6 16.75H7.5C8.2 16.75 8.88 17.09 9.3 17.65L10.6 19.38C10.93 19.82 11.44 20.08 12 20.08C12.56 20.08 13.07 19.82 13.4 19.38L14.7 17.65C15.12 17.09 15.8 16.75 16.5 16.75H18C20.07 16.75 21.75 15.07 21.75 13V7C21.75 4.93 20.07 3.25 18 3.25ZM20.25 13C20.25 14.24 19.24 15.25 18 15.25H16.5C15.33 15.25 14.2 15.81 13.5 16.75L12.2 18.48C12.07 18.65 11.93 18.65 11.8 18.48L10.5 16.75C9.8 15.81 8.67 15.25 7.5 15.25H6C4.76 15.25 3.75 14.24 3.75 13V7C3.75 5.76 4.76 4.75 6 4.75H18C19.24 4.75 20.25 5.76 20.25 7V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 8.75C10.4295 8.75 10.7695 8.41 10.7695 8C10.7695 7.59 10.4295 7.25 10.0195 7.25H10.0095C9.59953 7.25 9.26953 7.59 9.26953 8C9.26953 8.41 9.60953 8.75 10.0195 8.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0195 8.75C14.4295 8.75 14.7695 8.41 14.7695 8C14.7695 7.59 14.4295 7.25 14.0195 7.25H14.0095C13.5995 7.25 13.2695 7.59 13.2695 8C13.2695 8.41 13.6095 8.75 14.0195 8.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 10.5503C14.1603 12.2003 12.2203 12.2503 12.0003 12.2503C9.93027 12.2503 8.73027 10.7203 8.60027 10.5503C8.35027 10.2203 7.88027 10.1503 7.55027 10.4003C7.22027 10.6503 7.15027 11.1203 7.40027 11.4503C7.69027 11.8303 9.26027 13.7503 12.0003 13.7503C12.4803 13.7503 14.9603 13.6403 16.6003 11.4503C16.8503 11.1203 16.7803 10.6503 16.4503 10.4003C16.1203 10.1503 15.6503 10.2203 15.4003 10.5503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNavIcon);
export default __webpack_public_path__ + "static/media/chat_nav_icon.de16f966c0ac571df23874b9ca32b2df.svg";
export { ForwardRef as ReactComponent };